<template>
	<transition name="modal" appear>
		<div class="modal">
			<div class="modal-mask" v-on:click.self="$emit('close')">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-header text-center">
							<slot name="header">
								<button class="btn-default second" v-on:click.self="$emit('close')">
									닫기
								</button>
								<h3></h3>
							</slot>
						</div>
						<div class="modal-body">
							<slot name="body">
								<div class="step-box">
									<span></span>
									<span></span>
								</div>
								<div class="refund">
									<h3></h3>
									<p></p>
									<p></p>
								</div>
							</slot>
						</div>
						<div class="modal-footer text-right">
							<slot name="footer">
								<button class="btn-default second" v-on:click.self="$emit('close')"></button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'ModalFamppy',
};
</script>

<style scoped></style>
